import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import PaymentStatus from './components/PaymentStatus';
import Home from './pages/Home';
import Account from './pages/Account';
import ProtectedRoute from './components/ProtectedRoute';
import News from './components/News';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import styled from 'styled-components';
import './App.css';
import SelectUserPage from "./components/SelectUserPage";
import EditProfile from "./components/EditProfile";
import ChangePassword from "./components/ChangePassword";
import ChangeBillingDetails from "./components/ChangeBillingDetails";
import ProfileSettings from "./components/ProfileSettings";
import OrderHistory from "./components/OrderHistory";
import CommentNotification from "./components/CommentNotifications";
import PostDetail from "./components/PostDetail";
import CookieBanner from "./components/CustomCookieConsent";
import Messages from "./components/Messages";
import FAQ from "./components/Faq";
import DownloadPage from "./components/DownloadPage";
import SubscriptionDetails from "./components/SubscriptionDetails";
import BettingTipsList from "./components/BettingTipsList";
import Hero from "./landing/Hero";
import FullHome from "./landing/FullHome";
import Admin from "./pages/Admin";
import TermsOfService from "./pages/TermsOfService";
import TermsOfServiceArchive from "./pages/TermsOfServiceArchive";

const stripePromise = loadStripe('pk_live_51PexFn2LxS9rV2S4jEp30qRFF8DK5Crr6KxDD3NsnEgLrl12PZQ7hCENsCKyLf7O6TIuSMfNbnjfVHeGk0Osh2EW00Rf4hdjgi');

// Create a proper app container
const AppContainer = styled.div`
    min-height: 100vh;
    background-color: #f8f9fa;
`;

const MainContainer = styled.div<{ $isLandingPage?: boolean }>`
    width: 100%;
    max-width: ${props => props.$isLandingPage ? '100%' : '600px'};
    margin: 0 auto;
    background-color: ${props => props.$isLandingPage ? 'transparent' : '#f8f9fa'};
`;

const HeaderWrapper = styled.div<{ $isLandingPage?: boolean }>`
    width: 100%;
    max-width: ${props => props.$isLandingPage ? '100%' : '600px'};
    margin: 0 auto;
    background-color: ${props => props.$isLandingPage ? 'transparent' : '#f8f9fa'};
`;

// Component to conditionally render header based on route
const Layout: React.FC = () => {
    const location = useLocation();
    const isLandingPage = location.pathname === '/domov';

    React.useEffect(() => {
        if (location.pathname === '/domov') {
            const hash = location.hash.substring(1); // remove #
            let source = null;
            if (hash === 'fromig') {
                source = 'instagram';
            } else if (hash === 'fromyt') {
                source = 'youtube';
            } // Add more mappings as needed
            if (source && !localStorage.getItem('referral_source')) {
                localStorage.setItem('referral_source', source);
            }
        }
    }, [location]);

    return (
        <>
            {!isLandingPage && (
                <HeaderWrapper $isLandingPage={isLandingPage}>
                    <Header />
                </HeaderWrapper>
            )}
            <MainContainer $isLandingPage={isLandingPage}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/domov" element={<FullHome />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/aplikacia" element={<DownloadPage />} />
                    <Route path="/databaza-tipov" element={<BettingTipsList />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/podmienky" element={<TermsOfService />} />
                    <Route path="/podmienky-archiv" element={<TermsOfServiceArchive />} />

                    <Route element={<ProtectedRoute />}>
                        <Route path="/account" element={<Account />} />
                        <Route path="/payment-status" element={
                            <Elements stripe={stripePromise}>
                                <SubscriptionDetails></SubscriptionDetails>
                                <PaymentStatus />
                            </Elements>
                        } />
                        <Route path="/news" element={<News />} />
                        <Route path="/messages/select-user" element={<SelectUserPage />} />
                        <Route path="/edit-profile" element={<EditProfile/>} />
                        <Route path="/change-password" element={< ChangePassword/>} />
                        <Route path="/change-billing-details" element={<ChangeBillingDetails/>} />
                        <Route path="/profile-settings" element={<ProfileSettings/>} />
                        <Route path="/order-history" element={<OrderHistory />} />
                        <Route path="/comment-notification" element={<CommentNotification />} />
                        <Route path="/post/:id" element={<PostDetail />} />
                        <Route path="/messages/" element={<Messages />} />
                        <Route path="/predplatne/" element={<SubscriptionDetails />} />
                    </Route>
                </Routes>
            </MainContainer>
            <CookieBanner />
        </>
    );
};

const App: React.FC = () => {
    return (
        <AppContainer id="app-root"> {/* This ID is important */}
            <Router>
                <Layout />
            </Router>
        </AppContainer>
    );
};

export default App;